import { topicsData } from '@/mocks/home';

const trendIcons: Record<string, string> = {
  up: 'ri-arrow-up-line',
  hot: 'ri-fire-line',
  new: 'ri-sparkling-line',
};

const trendColors: Record<string, string> = {
  up: 'text-primary-500',
  hot: 'text-accent-500',
  new: 'text-accent-500',
};

const tagColors: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-800',
};

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto">
            当前最火的黑料爆料话题标签，点击查看相关报道。话题热度实时更新，刷新看看有没有新瓜。
          </p>
        </div>

        <div className="flex flex-wrap gap-2 md:gap-3 justify-center">
          {topicsData.map((topic) => (
            <a
              key={topic.id}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                const target = document.querySelector('#cards');
                if (target) {
                  const headerHeight = 64;
                  const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;
                  window.scrollTo({ top: targetPosition, behavior: 'smooth' });
                }
              }}
              className={`group inline-flex items-center gap-2 px-4 py-2.5 md:px-5 md:py-3 rounded-full border transition-all duration-200 cursor-pointer whitespace-nowrap ${
                topic.tagType
                  ? `bg-primary-50 border-primary-200 hover:bg-primary-100`
                  : 'bg-background-50 border-background-200/70 hover:border-foreground-300 hover:bg-background-100'
              }`}
            >
              <span
                className={`text-xs md:text-sm font-bold ${
                  topic.tagType ? 'text-primary-700' : 'text-foreground-700'
                }`}
              >
                {topic.name}
              </span>
              {topic.trend && (
                <i
                  className={`${trendIcons[topic.trend] || ''} ${
                    trendColors[topic.trend] || ''
                  } text-xs`}
                ></i>
              )}
              <span className="text-[10px] md:text-xs text-foreground-400">
                {topic.heat}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}